import { render } from "../../templates/selection/compare-products.html?vue&type=template&id=18f5f5ea&scoped=true"
import script from "./CompareProducts.vue?vue&type=script&lang=js"
export * from "./CompareProducts.vue?vue&type=script&lang=js"

import "./CompareProducts.vue?vue&type=style&index=0&id=18f5f5ea&lang=scss&scoped=true"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18f5f5ea"]])

export default __exports__